import { useWizard } from 'react-use-wizard';
import { AnimatedStep } from '../AnimatedStep';
import type { SetupData } from '../SetupWizard';

interface Props {
  data: SetupData;
  updateData: (updates: Partial<SetupData>) => void;
}

export function WorkHoursStep({ data, updateData }: Props) {
  const { nextStep, previousStep } = useWizard();

  const formatTime = (time: string) => {
    const [hours, minutes] = time.split(':');
    const h = parseInt(hours, 10);
    const ampm = h >= 12 ? 'PM' : 'AM';
    const h12 = h % 12 || 12;
    return `${h12}:${minutes} ${ampm}`;
  };

  return (
    <AnimatedStep>
      <div className="space-y-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            What are your work hours?
          </h2>
          <p className="text-gray-600">
            We'll schedule visits within these hours.
          </p>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Start Time
            </label>
            <input
              type="time"
              value={data.work_start_time}
              onChange={(e) => updateData({ work_start_time: e.target.value })}
              className="w-full px-4 py-4 text-lg border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-0 outline-none transition-colors"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              End Time
            </label>
            <input
              type="time"
              value={data.work_end_time}
              onChange={(e) => updateData({ work_end_time: e.target.value })}
              className="w-full px-4 py-4 text-lg border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-0 outline-none transition-colors"
            />
          </div>
        </div>

        <div className="bg-blue-50 rounded-xl p-4 text-center">
          <p className="text-blue-900 font-medium">
            {formatTime(data.work_start_time)} – {formatTime(data.work_end_time)}
          </p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={() => previousStep()}
            className="px-6 py-3 text-gray-600 font-medium hover:text-gray-900 transition-colors"
          >
            Back
          </button>
          <button
            onClick={() => nextStep()}
            className="flex-1 px-6 py-3 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 transition-colors"
          >
            Continue
          </button>
        </div>
      </div>
    </AnimatedStep>
  );
}
